import React from 'react'

import Loader from '../components/presentationals/Loader/Loader.component'

export const ALL_ROUTES = React.lazy(() => import('./NotFound.js'))

// website
export const LoginContainer = React.lazy(() => import('../components/containers/Admin/Login.container'));



export const Home = React.lazy(() => import('./Home.layout'))
export const ENACH_SIGNDESK = React.lazy(() => import('../components/containers/Home/EnachSigndesk'))
export const ENACH_SIGNDESK_MOBILE = React.lazy(() => import('../components/containers/Home/SigndeskIframe'))
export const Feedback = React.lazy(() => import('../components/containers/Admin/CustomerPages/UserFeedback.container'))
export const UPLOAD_DOCUMENT = React.lazy(() => import('../components/containers/Admin/UploadDocumentMail.container'))
export const ENACHPAGE = React.lazy(() => import('../components/containers/Home/Enach.container'))
export const ESIGNPAGE = React.lazy(() => import('../components/containers/Home/NewEsign.container'))
export const E_SIGN_PAGE_EV = React.lazy(() => import('../components/containers/Home/NewEsignEv.container.js'))
export const E_SIGN_PAGE_DIGITAP = React.lazy(() => import('../components/containers/Home/NewEsignDigitap.container.js'))

export const Reference = React.lazy(() => import('../components/containers/Forms/UserReference.container'))
export const EsignMobile = React.lazy(() => import('../components/containers/Home/EsignIfram.container'))
export const EnachMobile = React.lazy(() => import('../components/containers/Home/EnachIframe.container'))
export const EnachCardPage = React.lazy(() => import('../components/containers/Admin/CardsUtility/CardEnach And Esign/Enach.container'))
export const EsignCardPage = React.lazy(() => import('../components/containers/Admin/CardsUtility/CardEnach And Esign/NewEsign.container'))
export const SEIGNDESK_REDIRECT_URL = React.lazy(() => import('../components/containers/Home/signdeskRedirectPage'))
export const KYC_FORM = React.lazy(() => import('../components/containers/Home/kycForm'))
export const KYC_SIGNZY = React.lazy(() => import('../components/containers/Home/kycSignzy'))
export const KYC_DIGITAP = React.lazy(() => import('../components/containers/Home/kycDigitap'))
export const KYC_MOBILE = React.lazy(() => import('../components/containers/Home/kycMobile'))
export const DIGILOCKER_KYC = React.lazy(() => import('../components/containers/Home/digilockerkyc.js'))
export const KYC_FORM_DIGILOCKER = React.lazy(() => import('../components/containers/Home/kycFormDigilocker'))
export const KFS_PAGE = React.lazy(()=>import('../components/containers/Home/Kfsnew.js'))
export const LEGAL_NOTICE = React.lazy(() => import('../components/containers/Home/LegalNotice'));
export const KFS_PAGE_NEW = React.lazy(() => import('../components/containers/Home/KfsnewNew.js'))
export const ESIGN_REDIRECT_URL = React.lazy(() => import('../components/containers/Home/EsignRedirectPage'))
export const ESIGN_REDIRECT_DIGITAP_URL = React.lazy(() => import('../components/containers/Home/EsignRedirectDigitapPage'))
export const CRIF_URL = React.lazy(() => import('../components/containers/Home/crif'))
export const ESIGN_REDIRECT_URL_EV = React.lazy(() => import('../components/containers/Home/EsignRedirectPageEv'))
export const SOA = React.lazy(() => import('../components/containers/Home/SOA'))
export const EV_TVR_URL = React.lazy(() => import('../components/containers/Admin/EV_Module/EvApplication/ProfileAnalysis/TvrAnalysis.js'))
export const EV_LOANCHECK_URL = React.lazy(() => import('../components/containers/Admin/EV_Module/EvApplication/ProfileAnalysis/LoancheckForm.js'))
export const VIEW_TRANSACTION_RECIEPT = React.lazy(() => import('../components/containers/Home/ViewTransactionReciept.js'))

export const AdminLogin = React.lazy(() => import('../components/containers/Admin/Login.container'))

export const UPLOAD_DOCUMENT_REDIRECT = React.lazy(() => import('../components/containers/Home/UploadDocumentRedirect.js'));
export const LOAN_AGGREGEMENT_LINK = React.lazy(() => import('../components/containers/Home/LoanAggrementUrl.js'));
export const KYC_REDIRECT_URL = React.lazy(() => import('../components/containers/Home/KYCRedirectPage.js'));
export const KYC_DIGITAP_REDIRECT_URL = React.lazy(() => import('../components/containers/Home/KYCDigitapRedirectPage.js'));
export const ACCOUNT_AGGREGAOTR_LINK = React.lazy(() => import('../components/containers/Home/AccoutnAggregaotrRedirectionPage.jsx'));




